module.exports = __webpack_public_path__ + "img/battery-cap.25740fcf.svg";